export var COLOR;
(function (COLOR) {
    COLOR["PRIMARY"] = "#F5821F";
    COLOR["RED"] = "#D6482A";
    COLOR["BLACK"] = "#000000";
    COLOR["GREEN"] = "#4AC66F";
    COLOR["WHITE"] = "#FFFFFF";
    COLOR["OFF_WHITE"] = "#EAEAEA";
    COLOR["LIGHT_BG"] = "#F5F6FA";
    COLOR["GRAY"] = "#ACACAC";
    COLOR["BUTTON_PRIMARY"] = "#F58220";
    COLOR["BUTTON_DISABLED"] = "#898989";
    COLOR["DARK_GRAY"] = "#C7C7C7";
    COLOR["SHADOW"] = "#00000029";
    COLOR["PURPLE"] = "#434175";
    COLOR["PRIMARY_GREY"] = "#A1A1A1";
    COLOR["LIGHT_ORANGE"] = "rgba(245, 130, 32, .2)";
})(COLOR || (COLOR = {}));
export var INPUT_TYPE;
(function (INPUT_TYPE) {
    INPUT_TYPE["TEXT"] = "text";
    INPUT_TYPE["NUMBER"] = "number";
    INPUT_TYPE["PASSWORD"] = "password";
    INPUT_TYPE["RADIO"] = "radio";
    INPUT_TYPE["DROPDOWN"] = "dropdown";
    INPUT_TYPE["FILE"] = "file";
    INPUT_TYPE["DATE"] = "date";
})(INPUT_TYPE || (INPUT_TYPE = {}));
export var StyleType;
(function (StyleType) {
    StyleType["roundedInput"] = "rounded";
    StyleType["borderBottomInput"] = "line";
})(StyleType || (StyleType = {}));
export var CC_EMAIL_ID = "support@myshubhlife.com";
export var imageBaseUrl = "https://www.myshubhlife.com";
//# sourceMappingURL=variables.js.map